import styled, { css } from 'styled-components';

import { theme } from '../../../common/ui/theme';

const activeStyles = css`
    background-color: ${theme.colors.accent.background};
    color: ${theme.colors.accent.foreground};
`;

interface CalendarPresetEntryProps {
    active?: boolean;
}

export const CalendarPresetEntry = styled.div<CalendarPresetEntryProps>`
    padding: ${theme.space[8]} ${theme.space[24]};
    cursor: pointer;
    font-size: ${theme.fontSizes[14]};
    line-height: 24px;
    font-weight: ${theme.fontWeights[500]};
    border: none;

    &:hover {
        background-color: ${(props) =>
            props.active ? theme.colors.accent.background : theme.colors.background.subtle};
    }

    ${(props) => (props.active ? activeStyles : '')}
`;
